import type {
  ArticleObject,
  ArticlesPayload,
  GetArticleCoverImagesSuccess,
  GetBySlugPayload,
} from 'commons/types';
import {
  getArticleByIdTypes,
  getArticleBySlugTypes,
  getArticleListTypes,
  getArticlesTypes,
  setCurrentPage,
  getArticleCoverImagesTypes,
  clickOnRequestInfoTypes,
  clickOnShareTypes,
  getTaxonomyArticlesTypes,
} from './types';

const articlesActions = {
  getArticleByIdRequest: (payload: number) => ({
    type: getArticleByIdTypes.REQUEST,
    payload,
  }),
  getArticleByIdSuccess: (payload: ArticleObject) => ({
    type: getArticleByIdTypes.SUCCESS,
    payload,
  }),
  getArticleByIdFail: (payload: string) => ({
    type: getArticleByIdTypes.FAILED,
    payload,
  }),
  getArticlesInternalRequest: (payload: ArticlesPayload) => ({
    type: getArticlesTypes.REQUEST,
    payload,
  }),
  getArticlesInternalSuccess: (payload: ArticleObject) => ({
    type: getArticlesTypes.SUCCESS,
    payload,
  }),
  getArticlesInternalFail: (payload: string) => ({
    type: getArticlesTypes.FAILED,
    payload,
  }),
  getTaxonomyArticlesRequest: (payload: ArticlesPayload) => ({
    type: getTaxonomyArticlesTypes.REQUEST,
    payload,
  }),
  getTaxonomyArticlesSuccess: (payload: ArticleObject) => ({
    type: getTaxonomyArticlesTypes.SUCCESS,
    payload,
  }),
  getTaxonomyArticlesFailure: (payload: string) => ({
    type: getTaxonomyArticlesTypes.FAILURE,
    payload,
  }),
  setCurrentPage: (payload: number) => ({
    type: setCurrentPage.REQUEST,
    payload,
  }),
  getArticleBySlugRequest: (payload: GetBySlugPayload) => ({
    type: getArticleBySlugTypes.REQUEST,
    payload,
  }),
  getArticleBySlugSuccess: (payload: ArticleObject) => ({
    type: getArticleBySlugTypes.SUCCESS,
    payload,
  }),
  getArticleBySlugFail: (payload: string) => ({
    type: getArticleBySlugTypes.FAILED,
    payload,
  }),
  dismountArticle: () => ({
    type: getArticleBySlugTypes.DISMOUNT,
  }),
  getArticlesRequest: (payload: number) => ({
    type: getArticleListTypes.REQUEST,
    payload,
  }),
  getArticlesSuccess: (payload: ArticleObject) => ({
    type: getArticleListTypes.SUCCESS,
    payload,
  }),
  getArticlesFail: (payload: string) => ({
    type: getArticleListTypes.FAILED,
    payload,
  }),
  getArticleCoverImagesRequest: (searchTerm: string, page: number) => ({
    type: getArticleCoverImagesTypes.REQUEST,
    payload: {
      searchTerm,
      page,
    },
  }),
  getArticleCoverImagesSuccess: (payload: GetArticleCoverImagesSuccess) => ({
    type: getArticleCoverImagesTypes.SUCCESS,
    payload,
  }),
  getArticleCoverImagesFail: (payload: string) => ({
    type: getArticleCoverImagesTypes.FAILED,
    payload,
  }),
  clearArticleCoverImages: () => ({
    type: getArticleCoverImagesTypes.CLEAR,
  }),
  clickRequestInfoAd: () => ({
    type: clickOnRequestInfoTypes.CLICK_REQUEST_INFO,
  }),
  clickOnShareIcon: () => ({
    type: clickOnShareTypes.CLICK,
  }),
};
export default articlesActions;
